export default "__VITE_PUBLIC_ASSET__f2f87162__"